// **************************************************************************************************************
// ** global applications functions
// ************************************************
import { lightfair } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { apiSaveUserKeyboard } from "./apis";
import getCssFilter from "./rgbtoccs";
import { configurations_getDefaultAppParams, configurations_getDefaultPlayerParams, configurations_getDefaultTimeLineParams,configurations_getDefaultAppParams_checkvalues } from "./configurations";

export function getCurrentShortcutsVersion()
{
    return "1.30";
}

export function getCurrentVersion()
{
    return "Version 1.1.30.1 29/10/2026 " + GetIsFTVAChrome();
}

export function getCurrentErrorsVersion()
{
    return "1.03";
}

export function GetIsFTVAChrome()
{
    
    var ret = "";
    if (!navigator.userAgentData) return "";
    const userAgentData = navigator.userAgentData;
    console.log("user datas = ", userAgentData)
    if ("brands" in userAgentData)
    {
        userAgentData.brands.forEach(brand =>
            {
                if (brand.brand === "FTVA")
                    ret = " (Chromium FTVA Version "  + brand.version + ")";
            }
        )
    }
    return ret;
}


export function initApp() // call in index.js
{
    // create css filter icon color.
    var style = getComputedStyle(document.body)
    localStorage.setItem("default-icon-filter",getCssFilter(style.getPropertyValue('--default-icon-color')));
    localStorage.setItem("default-icon-filter-disabled",getCssFilter(style.getPropertyValue('--default-disable-icon-color')));
    localStorage.setItem("default-icon-simplemodal",getCssFilter(style.getPropertyValue('--simplepopup-icon-color')));

    // set language code
    getCurrentLanguage();
}





export function SearchCurrentKeyBoard()
{
    // 0 = windows // 1 = Mac
    const userAgent = navigator.userAgent.toLowerCase();
    console.log("user agent", userAgent)
    const userAgentData = navigator.userAgentData;
    console.log("user agent data ", userAgentData)
    if (userAgent.includes("mac")) return 1;
    return 0;
}

export function setCurrentKeyboard(keyboard)
{
    localStorage.setItem("current-keyboard",keyboard);
}

export function getCurrentKeyboard()
{
    var keyboard = localStorage.getItem("current-keyboard");
    if ((keyboard != 0) && (keyboard != 1)) keyboard = 0;
    localStorage.setItem("current-keyboard",keyboard);
    return keyboard;
}

export function setCurrentShortcutsList(liste,updatebase = true)
{
    const shortcuts_version = getCurrentShortcutsVersion();
    localStorage.setItem("current_shortcuts_list_" + shortcuts_version, liste); 

    if (updatebase) 
    {
        const id = getCurrentUserDatas().id;
        const version = getCurrentShortcutsVersion();
        if (id > 0)
        {
            const datas = {
                version: version,
                shortcuts: JSON.stringify(liste),
            }
            apiSaveUserKeyboard(datas,null);
        }
        
    }
}

export function getCurrentShortcutsList()
{
    const shortcuts_version = getCurrentShortcutsVersion();
    return localStorage.getItem("current_shortcuts_list_" + shortcuts_version); 
}


export function getMaxUndo()
{
    var maxundo = localStorage.getItem("undo-size");
    if (!maxundo) maxundo = 50;
    localStorage.setItem("undo-size",maxundo);
    return maxundo;
}

export function setMaxUndo(maxundo)
{
    localStorage.setItem("undo-size",maxundo);
}


export function getCurrentLanguage() {
  var style = getComputedStyle(document.body)
  const deflanguage = style.getPropertyValue('--default-language');
  var language = localStorage.getItem("current-language");
  if ((language !== "fr") && (language != "en")) {
    language = deflanguage;
    localStorage.setItem("current-language", language);
  }
  
  const html = document.querySelector("html");
  if (html && html.getAttribute("lang") !== language) {
    html.setAttribute("lang", language);
  }
  
  return language;

}

function langsel(cl,fr,en)
{
    return cl=="fr"?fr:en;
}


export function getDefaultErrorsOptions(optionsversion)
{
    var currentLanguage = getCurrentLanguage();
    return {
                version: optionsversion,
                values: [
                    { bloc: 1, label: langsel(currentLanguage,"Times codes non valides","Invalid times codes"), key: "TC1", value: true },
                    { bloc: 1, label: langsel(currentLanguage,"Intervalles","Intervals"), key: "TC2", value: true },
                    { bloc: 1, label: langsel(currentLanguage,"Durée (min/max)","Length (min/max)"), key: "TC3", value: false },
                    { bloc: 1, label: langsel(currentLanguage,"Changements de plan","Shots"), key: "TC4", value: false },

                    { bloc: 2, label: langsel(currentLanguage,"Lisibilité","Lisibility"), key: "TE1", value: true },
                    { bloc: 2, label: langsel(currentLanguage,"Longueur de ligne","Line length"), key: "TE2", value: true }
                ],
                titles: {
                    1: langsel(currentLanguage,"Erreurs sur times codes","Time code errors"),
                    2: langsel(currentLanguage,"Erreurs sur les textes","Texts errors"),
                }
            }

}

export function setCurrentErrorsOptions(options)
{
    localStorage.setItem("errorsoptions",JSON.stringify(options));
}

export function getCurrentErrorsOptions()
{
    const optionsversion = getCurrentErrorsVersion();
    const currentLanguage = getCurrentLanguage();
    var options = localStorage.getItem("errorsoptions");
    if (!options) return getDefaultErrorsOptions(optionsversion);
    
    try{
        options = JSON.parse(options);
        if ((currentLanguage != options.language) || (optionsversion != options.version)) return getDefaultErrorsOptions(optionsversion);
        return options;
    }
    catch(e)
    {
        return getDefaultErrorsOptions(optionsversion);
    }
}

export function setCurrentMode(newmode)
{
    localStorage.setItem("modes",JSON.stringify(newmode));
}
export function getCurrentMode()
{
    const mode = localStorage.getItem("modes");
    if (!mode)
        return {modeA: false, modeB: false, modeC: false};
    try
    {
        return JSON.parse(mode);
    }
    catch (e)
    {
        return {modeA: false, modeB: false, modeC: false};
    }
}

export function setCurrentModeTranscript(newmode)
{
    localStorage.setItem("modestranscript",JSON.stringify(newmode));
}
export function getCurrentModeTranscript()
{
    const mode = localStorage.getItem("modestranscript");
    if (!mode)
        return {modeA: false};
    try
    {
        return JSON.parse(mode);
    }
    catch (e)
    {
        return {modeA: false};
    }
}

export function setCurrentLanguage(language) {
  localStorage.setItem("current-language", language);
}


const User_Option_Display_Task = 1;

function GetDefaultUserOptions()
{
    const defaultOptions =  {
        displayOptions: User_Option_Display_Task,
        };
    
    return defaultOptions;


}

export function SetCurrentUserDisplayTasks(onoff)
{
    var userdatas = getCurrentUserDatas();
    if (onoff)
        userdatas.options.displayOptions = userdatas.options.displayOptions | User_Option_Display_Task;
    else
        userdatas.options.displayOptions = userdatas.options.displayOptions & ~(User_Option_Display_Task);

    setCurrentUserDatas(userdatas);
}


export function GetCurrentUserDisplayTasks()
{

    
    return ( GetCurrentUserOptions().displayOptions & User_Option_Display_Task );
}


export function GetCurrentUserOptions()
{
    return getCurrentUserDatas().options;
}

export function getCurrentUserDatas()
{

    var userdatas = localStorage.getItem("userdatas");
    if (userdatas != null)
    {
        try
        { 
            userdatas = JSON.parse(userdatas);
            if (!("options" in userdatas))
                userdatas.options = GetDefaultUserOptions();
            else
                if (!("displayOptions" in userdatas.options))
                    userdatas.options = GetDefaultUserOptions();
                

        }
        catch(e)
        {
            
            userdatas = {id:0, options: GetDefaultUserOptions()};
        }
    }
    else
        userdatas = {id:0, options: GetDefaultUserOptions()};
    return userdatas;

}

export function getCurrentProjectDatas()
{
    var userdatas = getCurrentUserDatas();
  
    
    var projectdatas = localStorage.getItem("projectdatas");
    
    if (projectdatas != null)
    {
        try
        { 

            projectdatas = JSON.parse(projectdatas);
            if (projectdatas.pjuser != userdatas.id)
                projectdatas = {pjid:0};
        }
        catch(e)
        {
            
            projectdatas = {pjid:0};
        }
    }
    else
    {
        projectdatas = {pjid:0};
    }

    localStorage.setItem("projectdatas", JSON.stringify(projectdatas));
    return projectdatas;

}

export function setCurrentProjectDatas(datas)
{
    if (datas == null)
    {
        
        localStorage.setItem("projectdatas", "");   
        return;
    }
    localStorage.setItem("projectdatas", JSON.stringify(datas));
}

export function setCurrentUserDatas(userdatas)
{
   
    localStorage.setItem("userdatas", JSON.stringify(userdatas));
    
   

}


// constantes utilisées par appexports.js et components.....

export const AppExport_ExportType = {
    notdefined: 0,
    video:1,
    transcription:2,
    subtitle:3,
  }


  //    *******************************************************************************************************************
  //    * layouts save / load
  //    *******************************************************************************************************************
  export function saveLayout (app, number, layout)
  {

        layout.forEach(element => {
            element.span="SPAN_X";
            
        });


        const jlayout = JSON.stringify(layout);
        const key="layout_" + app + "_" + number.toString();
        localStorage.setItem(key,jlayout);
  }


  export function getIsVisibleLayoutBlock(listeblock, block)
  {

        var ret=false;
        listeblock.forEach(bl => {
            if ((bl.id === block) && (bl.visible === "visible")) ret=true;
        })
        return ret;
  }

  
  export function loadLayout(app,number)
  {
    
    const key="layout_" + app + "_" + number.toString();
    var jlayout = localStorage.getItem(key);
    if (jlayout == null) return getDefaultLayout(app,1);
    try
    {
        var layout = JSON.parse(jlayout);
        layout.span = "SPAN_Y";
        return layout;
    }
    catch(e)
    {   
        getDefaultLayout(app,1);
    }
  }

  export function getDefaultTimeLineLayout(app, user)
  {
    var ret =  configurations_getDefaultTimeLineParams();

    switch (app)
    {
    case "transcription":
        // test sur la transcription uniquement
        try
        {
            const usertimeline = JSON.parse(user.timelinetr);
            if (user.timelinetr =="{}")
                console.log("user.timelinetr vide");
            else
            {
                console.log("Validation user time line tr");
                ret = usertimeline;
            }
        }
        catch (e)
        {
            console.log("user.timelinetr non valide");
        }
        return ret;

    case "subtitling":
        // test sur la sous titrage uniquement
        try
        {
            const usertimeline = JSON.parse(user.timelinest);
            if (user.timelinest =="{}")
                console.log("user.timelinest vide");
            else
            {
                console.log("Validation user time line st");
                ret = usertimeline;
            }
        }
        catch (e)
        {
            console.log("user.timelinest non valide");
        }
        return ret;
    }

  }

  export function getDefaultAppLayout(user)
  {
        var ret = configurations_getDefaultAppParams();
        
        try
        {
            const userappparam = JSON.parse(user.paramsapp);
            if (user.paramsapp =="{}")
                console.log("user.paramsapp vide");
            else
            {

                console.log("Validation user paramsapp");

                ret = configurations_getDefaultAppParams_checkvalues(userappparam);
            }
        }
        catch (e)
        {
            console.log("user.paramsapp non valide");
        }
        return ret;
  }


  export function getDefaultPlayerLayout(app, user)
  {
    var ret =  configurations_getDefaultPlayerParams();

    switch (app)
    {
    case "transcription":
        // test sur la transcription uniquement
        try
        {
            const usertimeline = JSON.parse(user.playertr);
            if (user.playertr =="{}")
                console.log("user.playertr vide");
            else
            {
                console.log("Validation user playertr tr");
                ret = usertimeline;
            }
        }
        catch (e)
        {
            console.log("user.playertr non valide");
        }
        return ret;

    case "subtitling":
        // test sur la sous titrage uniquement
        try
        {
            const usertimeline = JSON.parse(user.playerst);
            if (user.playerst =="{}")
                console.log("user.playerst vide");
            else
            {
                console.log("Validation playerst line st");
                ret = usertimeline;
            }
        }
        catch (e)
        {
            console.log("user.playerst non valide");
        }
        return ret;

    }

  }



  export function getUserDefaultLayout(user)
  {

        var ret = {
            transcription: {
                blocks: 
                {
                    usine1: getDefaultLayout("transcription",1),
                    usine2: getDefaultLayout("transcription",2),
                    user1: loadLayout("transcription", 1),
                    user2: loadLayout("transcription", 2),
                    user3: loadLayout("transcription", 3)
                },
                current: 0,
                timeline: getDefaultTimeLineLayout("transcription", user),
                player: getDefaultPlayerLayout("transcription", user),

            },
            subtitling: {
                blocks: 
                {
                    usine1: getDefaultLayout("subtitling",1),
                    usine2: getDefaultLayout("subtitling",2),
                    usine3: getDefaultLayout("subtitling",3),
                    user1: loadLayout("subtitling", 1),
                    user2: loadLayout("subtitling", 2),
                    user3: loadLayout("subtitling", 3)
                },
                current: 0,
                timeline: getDefaultTimeLineLayout("subtitling", user),
                player: getDefaultPlayerLayout("subtitling", user),
            },
            paramsapp: getDefaultAppLayout(user),
        };

        



        // test sur la transcription
        try
        {

            
            const usertr = JSON.parse(user.blockstr);
            if (usertr.length != 5)
                console.log("user.blockstr vide");
            else
            {
                
                ret.transcription.blocks.user1 = usertr[2];
                ret.transcription.blocks.user2 = usertr[3];
                ret.transcription.blocks.user3 = usertr[4];
                ret.transcription.current = user.currentblockstr;
            }


        }
        catch (e)
        {
            console.log("user.blockstr non valide");
        }
        
        // test sur le sous-titrage
        try
        {
            const userst = JSON.parse(user.blocksst);
            if (userst.length < 5)
                console.log("user.blocksst vide");
            else
            {
                var i=0;
                if (userst.length === 6) i=1;
                 console.log("Validation des blocks user ST");
                ret.subtitling.blocks.user1 = userst[2+i];
                ret.subtitling.blocks.user2 = userst[3+i];
                ret.subtitling.blocks.user3 = userst[4+i];
                ret.subtitling.current = user.currentblocksst;
            }
        }
        catch (e)
        {
            console.log("user.blocksst non valide");
        }
    return ret;
  }



  export function getDefaultLayout (app, number)
  {
        console.log ("get default layout", app, number)
        switch (app)
        {
            case "transcription":
            {
                switch (number)
                {
                    case 1:
                        return   [
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'49%',
                                height:'68.6%',
                                id: "transcription",
                                visible:"visible",
                                minWidth: "25%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'49%',
                                height:'68.6%',
                                id: "speakers",
                                visible:"hidden",
                                minWidth: "25%",
                                minHeight: "18%",
                                span: (<></>),
                            },

                            {
                                x:'50%',
                                y:'0.4%',
                                width:'50%',
                                height:'68.6%',
                                id: "player",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'0.0%',
                                y:'70.4%',
                                width:'100%',
                                height:'29%',
                                id: "timeline",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "visible",
                                span: (<></>),
                            },
                            {
                                x:'80.4%',
                                y:'70.4%',
                                width:'19.6%',
                                height:'29%',
                                id: "sequences",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "hidden",
                                span: (<></>),
                            },
                        ]; 

                    case 2:
                        return   [
                            {
                                x:'10.4%',
                                y:'0.4%',
                                width:'30%',
                                height:'63.6%',
                                id: "transcription",
                                visible:"visible",
                                minWidth: "25%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'10%',
                                height:'63.6%',
                                id: "speakers",
                                visible:"visible",
                                minWidth: "9%",
                                minHeight: "18%",
                                span: (<></>),
                            },

                            {
                                x:'40.8%',
                                y:'0.4%',
                                width:'36.1%',
                                height:'63.6%',
                                id: "player",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'0.0%',
                                y:'65.4%',
                                width:'77%',
                                height:'34%',
                                id: "timeline",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "visible",
                                span: (<></>),
                            },
                            {
                                x:'77.4%',
                                y:'0.4%',
                                width:'22.6%',
                                height:'99%',
                                id: "sequences",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "visible",
                                span: (<></>),
                            },

                        ]; 
                }

            }
            case "subtitling":
            {
                switch (number)
                {
                    case 1:
                        return   [
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'12%',
                                height:'63.6%',
                                id: "speakers",
                                visible:"visible",
                                minWidth: "9%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                            {
                                x:'42.8%',
                                y:'0.4%',
                                width:'34%',
                                height:'63.6%',
                                id: "player",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'77.2%',
                                y:'0.4%',
                                width:'22.8%',
                                height:'63.6%',
                                id: "transcription",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'0.0%',
                                y:'65.4%',
                                width:'100%',
                                height:'34.6%',
                                id: "timeline",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "visible",
                                span: (<></>),
                            },
                            {
                                x:'12.4%',
                                y:'0.4%',
                                width:'30%',
                                height:'63.6%',
                                id: "subtitles",
                                visible:"visible",
                                minWidth: "25%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                           {
                                x:'77.2%',
                                y:'0.4%',
                                width:'22.8%',
                                height:'99.6%',
                                id: "sequences",
                                visible: "hidden",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                        ]; 

                    case 2:
                        return   [
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'13%',
                                height:'68.6%',
                                id: "speakers",
                                visible:"visible",
                                minWidth: "9%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                            {
                                x:'79.2%',
                                y:'0.4%',
                                width:'20.8%',
                                height:'69.2%',
                                id: "transcription",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'16%',
                                y:'0.4%',
                                width:'60%',
                                height:'68.6%',
                                id: "player",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'0.0%',
                                y:'70.4%',
                                width:'100%',
                                height:'29%',
                                id: "timeline",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "visible",
                                span: (<></>),
                            },
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'30%',
                                height:'68.6%',
                                id: "subtitles",
                                visible:"hidden",
                                minWidth: "25%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                           {
                                x:'77.2%',
                                y:'0.4%',
                                width:'22.8%',
                                height:'99.6%',
                                id: "sequences",
                                visible: "hidden",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                             
                        ]; 
                     case 3:
                        return   [
                            {
                                x:'0%',
                                y:'0.4%',
                                width:'12%',
                                height:'63.6%',
                                id: "speakers",
                                visible:"visible",
                                minWidth: "9%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                            {
                                x:'42.8%',
                                y:'0.4%',
                                width:'34%',
                                height:'63.6%',
                                id: "player",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                            {
                                x:'0.0%',
                                y:'65.4%',
                                width:'76.8%',
                                height:'34.6%',
                                id: "timeline",
                                minWidth: "20%",
                                minHeight: "15%",
                                visible: "visible",
                                span: (<></>),
                            },
                            {
                                x:'12.4%',
                                y:'0.4%',
                                width:'30%',
                                height:'63.6%',
                                id: "subtitles",
                                visible:"visible",
                                minWidth: "25%",
                                minHeight: "18%",
                                span: (<></>),
                            },
                            {
                                x:'77.2%',
                                y:'0.4%',
                                width:'22.8%',
                                height:'99.6%',
                                id: "sequences",
                                visible: "visible",
                                minWidth: "15%",
                                minHeight: "15%",
                                span: (<></>),

                            },
                        ]; 
                }

            }

        }
  }
 